import { useState, useEffect } from 'react';
//use this hook to determine if current render is on server (ssr) or client
const useIsSsr = () => {
    const [isSsr, setIsSsr] = useState(true);
    useEffect(() => {
        setIsSsr(false);
    }, []);
    return isSsr;
};
export default useIsSsr;
//# sourceMappingURL=useIsSsr.js.map